// extracted by mini-css-extract-plugin
export var filterIncDec = "_c1-0";
export var leftBorder = "_c1-1";
export var rightBorder = "_c1-2";
export var stringInput = "_c1-3";